module.exports = __webpack_public_path__ + "static/media/icon-urgent-care.44137f6f.svg";